
export const APP_TRANSLATIONS = {
    pt: () => import("./pt.json"),
    en: () => import("./en.json"),
    es: () => import("./es.json"),
}
